(function () {

  console.log("Review verification loaded - Vercel");

  let verifiedClick = false;

  document.addEventListener("click", async function (event) {

    const reviewButton = event.target.closest(
      ".alr-wh-comp-filter-buttons-write-review"
    );

    if (!reviewButton) {
      return;
    }

    // Allow the original Ali Reviews click after verification
    if (verifiedClick) {
      verifiedClick = false;
      console.log("Opening Ali Reviews review form");
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    console.log("Write Review clicked");

    // --------------------------------
    // 1. CHECK LOGIN
    // --------------------------------

    if (!window.reviewVerification.loggedIn) {

      const returnUrl = window.location.pathname;

      window.location.href =
        "/account/login?return_url=" +
        encodeURIComponent(returnUrl);

      return;
    }

    // --------------------------------
    // 2. GET CUSTOMER + PRODUCT
    // --------------------------------

    const customerId =
      window.reviewVerification.customerId;

    const productId =
      window.reviewVerification.productId;

    console.log("Customer:", customerId);
    console.log("Product:", productId);

    // --------------------------------
    // 3. CHECK PURCHASE
    // --------------------------------

    try {

      const response = await fetch(
        "https://7dots-lac.vercel.app/api/review/check-purchase",
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json"
          },

          body: JSON.stringify({
            customerId: customerId,
            productId: productId
          })
        }
      );

      const data = await response.json();

      console.log("Purchase check:", data);

      // --------------------------------
      // 4. PURCHASED
      // --------------------------------

      if (data.allowed) {

        console.log("Customer purchased product");

        verifiedClick = true;

        // Trigger Ali Reviews' original click
        reviewButton.click();

        return;
      }

      // --------------------------------
      // 5. NOT PURCHASED
      // --------------------------------

      alert(
        "You can review this product only after purchasing it."
      );

    } catch (error) {

      console.error(
        "Purchase verification failed:",
        error
      );

      alert(
        "Unable to verify your purchase. Please try again."
      );
    }

  }, true);

})();